<template>
  <el-dialog v-model="dialogStatus" :close-on-click-modal="false" @close="close" :title="dialogTitle" :width="width"
    append-to-body>

    <el-form :model="form" :rules="rules" hide-required-asterisk ref="form" >
      <el-form-item prop="profitRate">
        <template v-slot:label>
          <div class="form-item__label">输入：</div>
        </template>
        <div>
          <el-input v-model="form.profitRate"  type="number" style="width:160px;margin-right: 10px;"
            placeholder="" />%
        </div>
        <div style="color:red">注释：输入0则为取消配置</div>
      </el-form-item>
    </el-form>

    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addProfitAteApp } from '@/api/manage/keyword/appWord'
import { appTypeList } from '@/const/app-type'
import SearchChannelSelect from '@/components/SearchChannelSelect'

const form = {
  appBundle: undefined,
  profitRate: undefined,
  queryWord: undefined
}
export default {
  components: {
    SearchChannelSelect
  },
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  inject: ['init'],
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,

      form: Object.assign({}, form),
      rules: {
        profitRate: [{ required: true, message: '请输入利润率', trigger: 'blur' }],
      },
      appTypeList: appTypeList
    }
  },
  created() { },
  computed: {
    dialogTitle() {
      return (this.title ? this.title : '') + (this.form.appBundle ? '编辑' : '新增')
    }
  },
  methods: {
    show(data) {
      data = {
        appBundle: data.appBundle,
        profitRate: data.profitRate,
        queryWord: data.keyword,
      }
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close() {
      this.dialogStatus = false
      // this.reset()
    },
    submit() {
      this.submitLoading = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.profitRate < 0) {
            this.$message.error('利润率不能为负')
            this.submitLoading = false
            return
          }
          addProfitAteApp(this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('配置成功')
              this.close()
              this.init()
              this.submitLoading = false
            }
          }).finally(() => {
            this.dialogStatus = false
          })
        }
      })
    },
    add(form) {
      this.submitLoading = true
    },
    update(form) {
      this.submitLoading = true
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
</style>
